import { render, staticRenderFns } from "./AccountMembershipView.vue?vue&type=template&id=5a1153de&scoped=true&"
import script from "./AccountMembershipView.vue?vue&type=script&lang=js&"
export * from "./AccountMembershipView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1153de",
  null
  
)

/* custom blocks */
import block0 from "./AccountMembershipView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports